<template>
  <v-card max-width="600px">
    <v-card-title>
      <v-layout row wrap>
        <v-flex xs6>
          <v-menu
            ref="menu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="queryParams.fromMonth"
                label="From Month"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="queryParams.fromMonth"
              type="month"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6>
          <v-menu
            ref="menu"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="queryParams.toMonth"
                label="To Month"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="queryParams.toMonth"
              type="month"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs6>
          <v-select
            :items="branchList"
            label="Select Branch"
            v-model="queryParams.branchId"
            item-text="name"
            item-value="id"
            :disabled="checkUserBranch() ? true : false"
          ></v-select>
        </v-flex>
        <v-flex xs6>
          <v-select
            :items="shopList"
            label="Select Shop"
            v-model="queryParams.shopId"
            item-text="name"
            item-value="id"
            :disabled="checkUserShop() ? true : false"
            class="ml-1"
          ></v-select>
        </v-flex>
        <v-flex xs6>
          <v-select
            :items="departmentList"
            label="Select Department"
            v-model="queryParams.departmentId"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            name="accountName"
            label="Account Name"
            type="text"
            v-model="queryParams.accountName"
            class="ml-1"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            name="assetName"
            label="Asset Name"
            type="text"
            v-model="queryParams.assetName"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-text-field
            name="assetType"
            label="Asset Type"
            type="text"
            v-model="queryParams.assetType"
            class="ml-1"
          ></v-text-field>
        </v-flex>
        <v-flex xs6>
          <v-btn color="primary" @click="close()">Close</v-btn>
        </v-flex>
        <v-flex xs6>
          <v-btn color="red" @click="clear">Reset</v-btn>
          <v-btn color="primary" @click="onSearch()">Search</v-btn>
        </v-flex>
      </v-layout>
    </v-card-title>
  </v-card>
</template>

<script>
import { branchService } from "../../services/branch-service";
import { shopService } from "../../services/shop-service";
import { departmentService } from "../../services/department-service";

export default {
  name: "AssetSummaryReportSearch",
  props: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    branchList: [],
    shopList: [],
    departmentList: [],
    queryParams: {
      fromMonth: new Date().toISOString().substring(0, 7),
      toMonth: new Date().toISOString().substring(0, 7),
      branchId: "",
      shopId: "",
      departmentId: "",
      accountName: "",
      assetName: "",
      assetType: "",
      branchName: "",
      shopName: "",
      departmentName: "",
    },
  }),
  created() {
    this.queryParams.branchId = this.checkUserBranch();
    this.queryParams.shopId = this.checkUserShop();
    this.getShopList().then(() => {
      this.getActiveBranchList().then(() => {
        this.onSearch();
      });
    });
    this.getActiveDepartmentList();
  },
  methods: {
    getShopList() {
      return shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveBranchList() {
      return branchService
        .getBranchByStatus("ACTIVE")
        .then((res) => {
          this.branchList = res.data;
          this.branchList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveDepartmentList() {
      departmentService
        .getDepartmentsByStatus("ACTIVE")
        .then((res) => {
          this.departmentList = res.data;
          this.departmentList.unshift({ id: "", name: "---All---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkUserShop() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "ASSET_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    checkUserBranch() {
      // if (this.user.role.roleName == "ASSET_MANAGER") {
      //   return this.user.branchId;
      // } else {
      return "";
      // }
    },
    clear() {
      this.queryParams.fromMonth = new Date().toISOString().substring(0, 7);
      this.queryParams.toMonth = new Date().toISOString().substring(0, 7);
      this.queryParams.branchId = "";
      this.queryParams.shopId = "";
      this.queryParams.departmentId = "";
      this.queryParams.accountName = "";
      this.queryParams.assetName = "";
      this.queryParams.assetType = "";
      this.queryParams.shopName = "";
      this.queryParams.departmentName = "";
      this.queryParams.branchName = "";
      this.onSearch();
    },
    close() {
      this.$emit("close");
    },
    onSearch() {
      if (this.queryParams.shopId)
        this.queryParams.shopName =
          this.shopList
            .filter((v) => v.id == this.queryParams.shopId)
            .map((shop) => shop.name)[0] || "";
      if (this.queryParams.departmentId)
        this.queryParams.departmentName =
          this.departmentList
            .filter((v) => v.id == this.queryParams.departmentId)
            .map((department) => department.name)[0] || "";
      if (this.queryParams.branchId)
        this.queryParams.branchName =
          this.branchList
            .filter((v) => v.id == this.queryParams.branchId)
            .map((branch) => branch.name)[0] || "";
      this.$emit("search", this.queryParams);
    },
  },
};
</script>
